/* eslint-disable prettier/prettier */
import React from 'react'
import { Global, css } from '@emotion/react'
import { INITIAL_QUERY_SUGGESTIONS_ID } from './utils'

const getStyles = () => {
  return css`
    .ais-SearchBox-input:focus {
      border-color: unset !important;
    }
    .ais-SearchBox-input {
      box-shadow: unset !important;
      height: 100% !important;
      padding-left: 44px !important;
      color: unset !important;
      caret-color: unset !important;
      font-size: 16px !important;
    }
    .ais-SearchBox-input::placeholder {
      color: unset !important;
      opacity: 0.5 !important;
    }
    .ais-SearchBox-form {
      height: 44px !important;
    }
    .ais-SearchBox-form::before {
      display: none !important;
    }
    .ais-SearchBox-submit {
      display: block !important;
      position: absolute;
      padding: 12px 10px 12px 16px;
    }
    .ais-SearchBox-submit .ais-SearchBox-submitIcon {
      width: 20px;
      height: 20px;
    }
    .ais-SearchBox-reset {
      fill: unset !important;
    }
    .ais-Highlight-highlighted {
      background-color: unset !important;
      color: #00d1d2;
    }
    #${INITIAL_QUERY_SUGGESTIONS_ID} button {
      height: unset !important;
    }
  `
}

const InstantSearchCSSOverride = props => <Global styles={getStyles(props)} />

export default InstantSearchCSSOverride
